<template>
  <div id="Hardware">
    <div class="banner">
      <img src="/static/images/features/hd_bg.png" alt="">
      <div class="bannerText">Lettuce Software</div>
    </div>
    <div class="content">
        <div class="con">
          <div class="left">
           <ul>
             <li :class="index ==selectId?'active':''" v-for="(item,index) in listImg" :key="item.title" @click="clickList(index)">{{$t(item.title)}}</li>
           </ul>
          </div>
          <div class="right">
            <div  v-for="(item,index) in listImg" :key="(item.titleSub,item.con)">
              <img v-if="index==selectId" :src="item.img" alt="">
              <div class="conText" v-if="index==selectId">
                <div class="tit">{{$t(item.title)}}</div>
                <div class="titSub">{{$t(item.titleSub)}}</div>
                <div class="explain">{{$t(item.con)}}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listImg:[
        {
          img:'/static/images/home/web/m_con3_1.png',
          title:'home.con2.table2.title1',
          titleSub:'home.con2.table2.titleSub1',
          con:'home.con2.table2.con1',
        },
       {
          img:'/static/images/home/web/m_con3_2.png',
          title:'home.con2.table2.title2',
          titleSub:'home.con2.table2.titleSub2',
          con:'home.con2.table2.con2',
        },
       {
          img:'/static/images/home/web/m_con3_3.png',
          title:'home.con2.table2.title3',
          titleSub:'home.con2.table2.titleSub3',
          con:'home.con2.table2.con3',
        },
       {
          img:'/static/images/home/web/m_con3_4.png',
          title:'home.con2.table2.title4',
          titleSub:'home.con2.table2.titleSub4',
          con:'home.con2.table2.con4',
        },
      ],
      selectId:0
    };
  },
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Hardware{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 21%;
      color: #333;
      font-size: 34px;
      font-weight: bold;
    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 60%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .left{
        width: 40%;
        ul{
          li{
            width: 70%;
            margin: 0 auto;
            padding: 15px;
            margin-top: 10px;
            color: #666;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            &.active{
              border-left: 5px solid #333;
              color: #333;
              background: #F4F4F4;
            }
          }
        }
      }
      .right{
        width: 60%;
        max-width: 860px;
        img{
          width: 100%;
        }
        .conText{
            padding: 15px 27px;
          .tit{
            font-size: 20px;
            color: #333;
            font-weight: bold;
          }
          .titSub{
            font-size: 18px;
            color: #333;
            font-weight: bold;
            padding: 10px 0;
          }
          .explain{
            font-size: 16px;
            color: #666;
          }

        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Features/Hardware.vue